import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageService } from 'src/app/demo/service/language.service';
import { languages } from 'src/app/demo/constants/languages';
import { NgxTranslateModule } from 'src/app/translate.module';


@Component({
  selector: 'app-progress-loader',
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    NgxTranslateModule
  ]
  , template: `
  <div class="loader-content">
    <span class="dialog-title">{{ 'Loading'|translate}}</span>
    <span class="loader"></span>
    <p>{{ 'Just a moment' | translate}}...</p>
  </div>
`,
  styles: [
    `
    .loader {
      transform: rotateZ(45deg);
      perspective: 1000px;
      border-radius: 50%;
      width: 48px;
      height: 48px;
      color: var(--color-primary);
    }
    .loader:before,
    .loader:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: inherit;
      height: inherit;
      border-radius: 50%;
      transform: rotateX(70deg);
      animation: 1s spin linear infinite;
    }
    .loader:after {
      color: var(--color-secondary);
      transform: rotateY(70deg);
      animation-delay: 0.4s;
    }

    @keyframes rotate {
      0% {
        transform: translate(-50%, -50%) rotateZ(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotateZ(360deg);
      }
    }

    @keyframes rotateccw {
      0% {
        transform: translate(-50%, -50%) rotate(0deg);
      }
      100% {
        transform: translate(-50%, -50%) rotate(-360deg);
      }
    }

    @keyframes spin {
      0%,
      100% {
        box-shadow: 0.2em 0px 0 0px currentcolor;
      }
      12% {
        box-shadow: 0.2em 0.2em 0 0 currentcolor;
      }
      25% {
        box-shadow: 0 0.2em 0 0px currentcolor;
      }
      37% {
        box-shadow: -0.2em 0.2em 0 0 currentcolor;
      }
      50% {
        box-shadow: -0.2em 0 0 0 currentcolor;
      }
      62% {
        box-shadow: -0.2em -0.2em 0 0 currentcolor;
      }
      75% {
        box-shadow: 0px -0.2em 0 0 currentcolor;
      }
      87% {
        box-shadow: 0.2em -0.2em 0 0 currentcolor;
      }
    }

    .dialog-title {
      font-size: 1.15rem;
      font-weight: 600;
      color: var(--text-color);
      margin-bottom: var(--margin-medium);
    }
    .loader-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 2rem;
    }
    p {
      margin-top: 1rem;
      font-size: 1rem;
      color: var(--text-color);
    }
  `,
  ],
})
export class ProgressLoaderComponent {

  selectedLanguage: any = null;

  constructor(
    public config: DynamicDialogConfig,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    
  }

  ngOnInit() {
    this.initializeLocale();
  }

  initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }
}
